export enum PageOwnerType {
    Witco = 0,
    Client = 1
}